export function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}
export function scrollToTopRef(ref: any) {
        ref.current?.scrollTo(0, 0);
}
